// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout__Layout___2wiTF"};